export default {
  getAparienciaTpl: state => {
    let table = 'Apariencia'
    switch (state.operacion) {
      case 'edit':
      case 'new':
        table = `${table}Form`
        break
      default:
        table = `${table}List`
        break
    }
    return table
  },
}
